import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BatchManager from "../../common/components/upload/BatchManager";
import { useBatchProcessor } from "../../common/hooks/useBatchProcessor";

export default function SustinaTaxonomyView() {
  const navigate = useNavigate();
  const [year, setYear] = useState(new Date().getFullYear());
  const [label, setLabel] = useState("EFRAG Taxonomy Set 1");
  const { startBatchSequence, isProcessing, error } = useBatchProcessor();
  const [successMessage, setSuccessMessage] = useState(null);

  const handleStartSequence = async (batchFileData) => {
    const companyId = sessionStorage.getItem('SEC_USER_COMPANY_ID') || "TEMP_ID";
    const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    const manifestName = `CID${companyId}_${timestamp}_1_TAXONOMY_manifest.jsonl`;

    const result = await startBatchSequence({
        batchType: batchFileData.batchType,
        companyId: companyId,
        manifestName: manifestName,
        file: batchFileData.file, 
        totalBatchSizeMB: batchFileData.totalBatchSizeMB, // From BatchManager Master
        fileCount: batchFileData.fileCount,             // From BatchManager Master
        metadata: { versionLabel: label, reportingYear: year }
    });

    if (result?.success) setSuccessMessage("Batch registered successfully.");
  };

  return (
    <main id="main" className="page-main mt-5 pt-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="h4 fw-bold mb-0">ESRS Taxonomy Sync</h2>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => navigate("/registered/site-admin")}>
                &larr; Return
              </button>
            </div>

            <div className="card shadow-sm border-0 mb-4 bg-light">
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="small fw-bold">Reporting Year</label>
                    <input type="number" className="form-control" value={year} disabled={isProcessing} onChange={(e) => setYear(e.target.value)} />
                  </div>
                  <div className="col-md-8">
                    <label className="small fw-bold">Version Label</label>
                    <input type="text" className="form-control" value={label} disabled={isProcessing} onChange={(e) => setLabel(e.target.value)} />
                  </div>
                </div>
              </div>
            </div>

            <BatchManager
              title="Sustina Taxonomy Sync"
              batchType={1}
              onStart={handleStartSequence}
              isSubmitting={isProcessing}
              error={error}
              successMessage={successMessage}
            />
          </div>
        </div>
      </div>
    </main>
  );
}